import { createSlice } from "@reduxjs/toolkit";
import { DataRoomFund } from "@dataRoomSetup/models";

const initialState: DataRoomFund = {
  selectedFund: "",
  fundId: "",
  dataRoomEditable: false,
  isOpenDataRoomDialog: false,
};

export const dataRoomSetupSlice = createSlice({
  name: "dataRoomSetup",
  initialState,
  reducers: {
    resetDataRoomSetupState: (state) => {
      state.selectedFund = initialState.selectedFund;
      state.fundId = initialState.fundId;
      state.isOpenDataRoomDialog = initialState.isOpenDataRoomDialog;
      // Keep edit mode as-is; do not reset dataRoomEditable here
    },
    openDataRoomSetupDialog: (state) => {
      state.isOpenDataRoomDialog = true;
      state.dataRoomEditable = true;
    },
    closeDataRoomSetupDialog: (state) => {
      state.isOpenDataRoomDialog = false;
    },
    hideDataRoomSetupDialog: (state) => {
      state.isOpenDataRoomDialog = false;
    },
    exitEditMode: (state) => {
      state.dataRoomEditable = false;
    },
    enterEditMode: (state) => {
      state.dataRoomEditable = true;
    },
  },
});
export const {
  resetDataRoomSetupState,
  openDataRoomSetupDialog,
  closeDataRoomSetupDialog,
  hideDataRoomSetupDialog,
  exitEditMode,
  enterEditMode,
} = dataRoomSetupSlice.actions;
export default dataRoomSetupSlice.reducer;
